function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.a{fill:none;}.bb{}\n"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 25.721) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M0,0H25.721V25.721H0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "bb",
  d: "M20.147,12.645v7.5h-15v-7.5H3v7.5a2.15,2.15,0,0,0,2.143,2.143h15a2.15,2.15,0,0,0,2.143-2.143v-7.5Zm-6.43.718L16.493,10.6,18,12.109l-5.358,5.358L7.287,12.109,8.8,10.6l2.776,2.765V3h2.143Z",
  transform: "translate(0.215 0.215)"
}));

var SvgImportGreen = function SvgImportGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.721,
    height: 25.721,
    viewBox: "0 0 25.721 25.721",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImportGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/importGreen.cc5fa106.svg";
export { ForwardRef as ReactComponent };